import routeUpdateReducer from '@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer';
import { reducer as dataSourceListReducer } from './views/DataSourceList/ducks';
import { reducer as dataSourceDetailReducer, } from './views/DataSourceDetail/ducks';
import { reducer as dataSourceOverrideDetailReducer, } from './views/DataSourceDetail/ducks/DataSourceOverrideDetail.ducks';
import { reducer as dataSourceAccessReducer, } from './views/DataSourceDetail/ducks/DataSourceAccess.ducks';
import { reducer as dataSourceSchemaReducer, } from './views/DataSourceDetail/ducks/DataSourceDetailSchema.ducks';
import { reducer as dataSourceHistoryReducer, } from './views/DataSourceDetail/ducks/DataSourceDetailHistory.ducks';
import { dataSourceProfilingReducer, } from './views/DataSourceDetail/ducks/DataSourceProfiling.ducks';
import { reducer as dataSourceOverrideListReducer, } from './views/DataSourceDetail/ducks/DataSourceDetailOverrideList.ducks';
import { reducer as dataSourceStatusReducer, } from './views/DataSourceDetail/ducks/DataSourceDetailStatus.ducks';
import { dataSourceDuplicateReducer, } from './views/DataSourceCreate/ducks/DataSourceDuplicate.ducks';
import { dataSourceFlightFormatsReducer, } from './views/DataSourceCreate/ducks/DataSourceFlightFormats.ducks';
import { dataSourceDeleteReducer, } from './views/DataSourceList/ducks/DataSourceDelete.ducks';
import { dataSourceCloneReducer, } from './views/DataSourceList/ducks/DataSourceClone.ducks';
import { combineReducers } from 'redux';
import DataSourceListReducer from './views/DataSourceList/ducks/DataSourceListFilter.ducks';
import DataSourceDetailReducer from './views/DataSourceDetail/ducks/DataSourceDetailContext.ducks';
import dataSourceCreateReducer from './views/DataSourceCreate/ducks/DataSourceCreate.ducks';
import dataSourceUpdateReducer from './views/DataSourceCreate/ducks/DataSourceUpdate.ducks';
import loadServicePrincipalNameListReducer from './views/DataSourceCreate/ducks/ServicePrincipalList.ducks';
import loadManagedIdentityNameListReducer from './views/DataSourceCreate/ducks/ManagedIdentityList.ducks';
import dataSourceOverrideCreateReducer from './views/DataSourceOverrideCreate/ducks/DataSourceCreate.ducks';
import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import getWorkspaceReducersMapObject from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks';
import UserAccessReducersMapObject from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer';
import LoadSubscribersReducersMapObject from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.ducks';
import SetSubscribersReducersMapObject from '@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks';
import LoadSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks';
import SetSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks';
export const moduleReducer = {
    ...routeUpdateReducer,
    ...currentUserDetailsReducersMapObject,
    ...getWorkspaceReducersMapObject,
    ...UserAccessReducersMapObject,
    ...LoadSubscribersReducersMapObject,
    ...SetSubscribersReducersMapObject,
    ...LoadSubscribersReducersMapObjectV2,
    ...SetSubscribersReducersMapObjectV2,
    dataSourceManagementModule: combineReducers({
        dataSourceUpdate: dataSourceUpdateReducer,
        dataSourceCreate: dataSourceCreateReducer,
        dataSourceListState: DataSourceListReducer,
        dataSourceList: dataSourceListReducer,
        dataSource: dataSourceDetailReducer,
        dataSourceDetailState: DataSourceDetailReducer,
        dataSourceAccess: dataSourceAccessReducer,
        dataSourceSchema: dataSourceSchemaReducer,
        dataSourceHistory: dataSourceHistoryReducer,
        dataSourceOverride: dataSourceOverrideDetailReducer,
        dataSourceOverrideCreate: dataSourceOverrideCreateReducer,
        dataSourceOverrideList: dataSourceOverrideListReducer,
        dataSourceStatus: dataSourceStatusReducer,
        dataSourceDuplicate: dataSourceDuplicateReducer,
        dataSourceDelete: dataSourceDeleteReducer,
        dataSourceClone: dataSourceCloneReducer,
        dataSourceFlightFormats: dataSourceFlightFormatsReducer,
        dataSourceProfiling: dataSourceProfilingReducer,
        servicePrincipalList: loadServicePrincipalNameListReducer,
        managedIdentityList: loadManagedIdentityNameListReducer,
    }),
};
export default moduleReducer;

//# sourceMappingURL=reducers.js.map
